import React from 'react'

import Button from 'app/components/ButtonDefault'
import TrashIcon from 'app/components/SVGS/TrashIcon'
import PlusIcon from 'app/components/SVGS/Plus'
import { EColors } from 'app/constants/colors'
import { PlusMinusButtonsProps } from './PlusMinusButtons.interface'

import './styles.scss'

const bc = 'plus-minus-buttons'

const PlusMinusButtons: React.FC<PlusMinusButtonsProps> = ({
  onAdd,
  onRemove,
  className,
  addingDisabled,
  deletingDisabled,
  addingHidden = false,
}) => (
  <div className={`${bc}__count-controls ${className ?? ''}`}>
    {!addingHidden && (
      <Button
        type="button"
        className={`${bc}__count-control ${bc}__count-control--add`}
        onClick={onAdd}
        disabled={addingDisabled}
        icon={
          <PlusIcon
            svgProps={{
              width: 40,
              height: 40,
            }}
            pathProps={{
              fill: EColors.WHITE,
            }}
          />
        }
      />
    )}

    <Button
      type="button"
      className={`${bc}__count-control ${bc}__count-control--delete`}
      onClick={onRemove}
      disabled={deletingDisabled}
      icon={
        <TrashIcon
          width={15}
          height={15}
          pathProps={{
            fill: EColors.WHITE,
          }}
        />
      }
    />
  </div>
)

export default PlusMinusButtons
